export const LOCAL_STORAGE_VENUE_KEY = "TICKETINGPLATFORM_VENUE";

export const LOCAL_STORAGE_PAYMENT_TERMINAL_KEY =
  "TICKETINGPLATFORM_PAYMENT_TERMINAL";

export const LOCAL_STORAGE_ORDER_KEY_PREFIX =
  "TICKETING_PLATFORM_WIDGET_ORDER_ID";
